import { MouseEventHandler } from 'react'
import Icon from '@material-ui/core/Icon'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  iconButton: {
    background: 'none',
    border: 'none',
    color: theme.palette.grey[800],
    cursor: 'pointer',
    padding: theme.spacing(1),
    fontSize: '1.5rem',
    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.grey[200],
      borderRadius: theme.shape.borderRadius * 2,
      padding: theme.spacing(1),
      boxShadow: theme.shadows[1],
      transition: 'color 0.3s ease',
    },
    '& span': {
      verticalAlign: 'middle',
      fontSize: 'inherit',
    },
  },
}))

const IconButton = ({
  icon,
  onClick,
}: {
  icon: string
  onClick: MouseEventHandler<HTMLButtonElement>
}) => {
  const classes = useStyles()
  return (
    <button className={classes.iconButton} onClick={onClick}>
      <Icon>{icon}</Icon>
    </button>
  )
}

export default IconButton
